<template>
	<Card>
		<template #content>
		<FileInput
		        data-cy="add-release-note-input"
				v-model="form.file"
				:label="$t('forms.firmware.firmware_release_notes_form.add_release_note')"
				:error-text="form.errors?.file"
				@change="form.validate('file')"
		/>
		</template>

		<template v-if="hasOnSaveListener" #footer>
			<div class="flex justify-end">
				<Button @click="$emit('on-save', form)" :label="$t('forms.common.save')" :disabled="form.processing"/>
			</div>
		</template>
	</Card>
</template>

<script>
import FileInput from "@/Components/FileInput.vue";

export default {
	name: "FirmwareReleaseNotesForm",
	components: {
		FileInput,
	},
	props: {
		form: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			file: null,
		}
	},
	computed: {
		hasOnSaveListener() {
			return !!(this.$attrs?.onOnSave);
		},
	},
}
</script>

<style scoped>

</style>